import { View, ViewProps } from "react-native";
import React from "react";

interface HiddenViewProps extends ViewProps {
  shouldHide: boolean;
  children: React.ReactNode;
}
const HiddenView: React.FC<HiddenViewProps> = ({
  children,
  shouldHide,
  style,
  ...rest
}) => {
  return (
    <View
      style={[
        style,
        {
          display: shouldHide ? "none" : "flex",
          overflow: "hidden",
        },
      ]}
      {...rest}
    >
      {children}
    </View>
  );
};

export default HiddenView;
